import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateBetweenValidator(start: Date | null, end: Date | null): any {
	return (control: AbstractControl): ValidationErrors | null => {
		if (control.value) {
			const date = new Date(control.value);

			if (start) {
				if (date < start) {
					return {
						dateStart: true,
					};
				}
			}

			if (end) {
				if (date > end) {
					return {
						dateEnd: true,
					};
				}
			}
		}

		return null;
	};
}
